import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=fbe731fa"
import script from "./menu-group.vue?vue&type=script&lang=js"
export * from "./menu-group.vue?vue&type=script&lang=js"
import style0 from "./menu-group.vue?vue&type=style&index=0&id=fbe731fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports